import type { CheckoutRpcClient } from "@redotech/checkout-sdk/rpc/client";
import { createCheckoutRpcClient } from "@redotech/checkout-sdk/rpc/client";
import { createContext, useMemo } from "react";
import { parseWidgetSlug } from "../basename";

export const RpcClientContext = createContext<CheckoutRpcClient | undefined>(
  undefined,
);

export const RpcClientProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const rpcClient = useMemo(() => {
    const widgetSlug = parseWidgetSlug(location.pathname);
    return createCheckoutRpcClient({
      baseURL: new URL(
        `${globalThis.REDO_CHECKOUT_SERVER_URL ?? "http://localhost:8060"}/rpc`,
      ),
      headers: widgetSlug ? { "X-WIDGET-ID": widgetSlug } : {},
    });
  }, []);

  return (
    <RpcClientContext.Provider value={rpcClient}>
      {children}
    </RpcClientContext.Provider>
  );
};
